// Mapeo exacto verificado en Product.tsx:26-27 (Lovable) — entero simple,
// distinto del mapeo mas preciso de la Guia de Tallas (13.4cm/EU21=US5.5).
// No reconciliar: es el comportamiento real del selector de producto.
const EU_TO_US = { '21': '5', '22': '6', '23': '7', '24': '8', '25': '9' };

class SizeUnitToggle extends HTMLElement {
  connectedCallback() {
    this.fieldset = this.closest('fieldset');
    if (!this.fieldset) return;

    this.inputs = Array.from(
      this.fieldset.querySelectorAll('input[data-option-name="Talla del calzado"]')
    );
    this.buttons = Array.from(this.querySelectorAll('[data-unit]'));

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.setUnit(button.dataset.unit));
    });

    this.setUnit('eu');
  }

  setUnit(unit) {
    this.buttons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.unit === unit);
    });

    this.inputs.forEach((input) => {
      const label = this.fieldset.querySelector(`label[for="${input.id}"]`);
      if (!label) return;

      const digits = input.value.replace(/^EU/, '');
      const display = unit === 'us' ? EU_TO_US[digits] || digits : digits;
      const textNode = Array.from(label.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE
      );
      if (textNode) textNode.nodeValue = display;
    });
  }
}

customElements.define('size-unit-toggle', SizeUnitToggle);
